// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__5saXS","email":"Contact_email__F4LmI","qrcode":"Contact_qrcode__eNr5W"};